import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UserService } from '../user/user.service';

/**
 * Password Change Guard
 * Forces users created by admin to change their password on first login
 * Redirects to /change-password if mustChangePassword is true
 *
 * Usage in routes:
 * {
 *   path: '',
 *   ...canActivate(() => passwordChangeGuard()),
 * }
 */
export const passwordChangeGuard: CanActivateFn = (route) => {
   const userService = inject(UserService);
   const router = inject(Router);

   // Skip guard for change-password route itself
   if (route.routeConfig?.path === 'change-password') {
      return true;
   }

   return userService.currentUser$.pipe(
      map((user) => {
         if (user?.mustChangePassword) {
            router.navigate(['/change-password']);
            return false;
         }
         return true;
      }),
   );
};
